export default {
    CodeMismatchException: 'pages.forgotcredentials.code.mismatch.exception',
    ExpiredCodeException: 'pages.forgotcredentials.expired.code.exception',
    InvalidParameterException: 'pages.forgotcredentials.InvalidParameterException',
    LimitExceededException: 'pages.forgotcredentials.limit.exceeded.exception',
    NotAuthorizedException: 'pages.forgotcredentials.NotAuthorizedException',
    ResourceNotFoundException: 'pages.forgotcredentials.ResourceNotFoundException',
    TooManyFailedAttemptsException: 'pages.forgotcredentials.limit.exceeded.exception',
    UserNotFoundException: 'pages.forgotcredentials.UserNotFoundException',
};
